import { signInWithPopup, signInWithEmailAndPassword } from 'firebase/auth'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { auth, googleAuthProvider } from '../../db'
import { FcGoogle } from 'react-icons/fc'
import {
  Button,
  Divider,
  Flex,
  Input,
  Link,
  Text,
  useToast
} from '@chakra-ui/react'
import { useIntl } from 'react-intl'
import messages from './messages'
import InternalStandaloneLayout from '../../components/InternalStandaloneLayout'

export default function Login() {
  const navigate = useNavigate()
  const { formatMessage } = useIntl()

  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState('')

  const toast = useToast()

  const handleGoogleLogin = () => {
    signInWithPopup(auth, googleAuthProvider)
      .then(() => {
        toast({
          title: formatMessage(messages.welcomeTitle),
          description: formatMessage(messages.welcomeDescription),
          status: 'success',
          duration: 4000,
          isClosable: true
        })
        navigate('/dashboard')
      })
      .catch((error: any) => {
        const errorMessage = error.message

        toast({
          title: formatMessage(messages.errorTitle),
          description: errorMessage,
          status: 'error',
          duration: 4000,
          isClosable: true
        })
      })
  }

  const handleEmailLogin = async () => {
    try {
      await signInWithEmailAndPassword(auth, email, password)
      toast({
        title: formatMessage(messages.welcomeTitle),
        description: formatMessage(messages.welcomeDescription),
        status: 'success',
        duration: 4000,
        isClosable: true
      })
      navigate('/dashboard')
    } catch (error: any) {
      const errorMessage = error.message

      toast({
        title: formatMessage(messages.errorTitle),
        description: errorMessage,
        status: 'error',
        duration: 4000,
        isClosable: true
      })
    }
  }

  return (
    <InternalStandaloneLayout
      title={formatMessage(messages.welcomeBackTitle)}
      description={formatMessage(messages.welcomeBackSubtitle)}
    >
      <Flex flexDir="column" gap={5}>
        <Input
          placeholder={formatMessage(messages.emailPlaceholder)}
          size="md"
          onChange={(event) => {
            setEmail(event.target.value)
          }}
        />
        <Input
          placeholder={formatMessage(messages.passwordPlaceholder)}
          type="password"
          size="md"
          onChange={(event) => {
            setPassword(event.target.value)
          }}
        />
        <Button
          colorScheme="gray"
          size="md"
          onClick={handleEmailLogin}
          mt={2}
          fontWeight="semibold"
        >
          {formatMessage(messages.loginButton)}
        </Button>

        <Flex align="center" my={2}>
          <Divider />
          <Text px={3} color="gray.400" fontSize="sm" fontWeight="medium">
            OR
          </Text>
          <Divider />
        </Flex>

        <Button
          onClick={handleGoogleLogin}
          variant="outline"
          size="md"
          w="full"
          leftIcon={<FcGoogle />}
          fontWeight="semibold"
        >
          {formatMessage(messages.googleLoginButton)}
        </Button>

        <Flex justifyContent="center" mt={4}>
          <Link
            color="gray.700"
            textDecoration="underline"
            fontWeight="medium"
            href="/signup"
          >
            {formatMessage(messages.signupLink)}
          </Link>
        </Flex>
      </Flex>
    </InternalStandaloneLayout>
  )
}
